

import React, { Fragment, useEffect, useRef, useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import { AttributeDefinition, AttributeInputType, GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import { UpdateStyleFunction } from "../Stylebuilder";
import SelectField from "./SelectField";
import Accordian from "../Accordian";
import SliderField from "./SliderFeild";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { SiteData } from "../Data/SiteData";
import ButtonField from "./ButtonsField";
import ReactDOM from "react-dom";
import VGPopUp from "vagaro-website-rendering/src/components/Controls/VGPopUp";



export default function CustomClipShape({label,saveFunc,layoutObject,definition,updateFunc,screenSize,siteData }:AttributeFieldProps){


    const [shouldSnap,setShouldSnap] = useState(false);
    const getClipShape = GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize,"ploygon(");
  
    const [selectKey,setSelectKey] = useState(0);

    const canvasSize = 200;
    const getPointsFromClipShapeString= (shape:string)=>{

  
        shape = shape.replace("polygon(","").replace(")","");
        let pointSplit = shape.split(",");
        let newPoints = []
        for(let i = 0;i<pointSplit.length;i++){
            let point = pointSplit[i].trim();
            let coords = point.split(" ");
            if(coords.length!=2){
                continue;
            }
            let x = parseFloat(coords[0].replace("%",""))??0;
            let y = parseFloat(coords[1].replace("%",""))??0;



            x= (x*canvasSize)/100;
            y= (y*canvasSize)/100;

      
       
            newPoints.push({x:x,y:y});

        }

        return newPoints;
}

    let getPoints = getPointsFromClipShapeString(getClipShape);

    
    const [clipShape,setClipShape] = useState(getClipShape);
    const [points,setPoints] = useState(getPoints);
    const [dragState,setDragState] = useState(-10);
    
  
    const canvasRef = useRef<HTMLDivElement>(null);

    const onSelectUpdate:UpdateStyleFunction = (attribute,value,targetType)=>{

        if(value==="generate-wave"){
            //open wave generator
            let dom = document.getElementById("OpenDialog");

            const PopupClose = () => {
                setSelectKey(selectKey+1)
                if(dom)
                    ReactDOM.unmountComponentAtNode(dom);
            }

            const settings = {
                amplitude:1,
                freq:.8,
                xOffset:0,
                yOffset:0,
                inverted:false,
            }

  
            if(dom){

    
                ReactDOM.render(
                    <>
                    <VGPopUp
                      id={"wave-popup"}
                      show={true}
                      onHide={PopupClose}
                      title={"Generate Wave"}
                      dialogClassName="block-edit"
                      body={
                        <div className="alertContent">
                         <GenerateWaveMenu siteData={siteData} settings={settings}/>
                        </div>
                      }
                      footer={
                        <Fragment>
                         
                        <button className="w-button w-button-secondary" onClick={(e) => {
                 
                            setSelectKey(selectKey+1)
                            PopupClose();}}>Cancel</button>
                        <button className="w-button w-button-primary" onClick={(e) => { 
                            let wave = GenerateWave(settings.freq,settings.xOffset,settings.yOffset,settings.amplitude,settings.inverted);
                            updateFunc(attribute,wave,targetType);
                            setClipShape(wave);
                            setPoints(getPointsFromClipShapeString(wave));
                            saveFunc();
                            PopupClose();}}>Apply</button>
                        </Fragment >
                      }
                      isRemoveTabModalIndex={false}
                      isShowFooter={true}
                      size={"modal-sm"}
                      backdrop={true}
                    />
              
                    </>,
                    dom);
            }
      

            return;
        }

        setClipShape(value);
        setPoints(getPointsFromClipShapeString(value));
        updateFunc(attribute,value,targetType);
  
    }

    const updateMouse = (e:MouseEvent)=>{

      
        if(dragState>=0 && canvasRef.current){
    
            let newPoint = {x:e.clientX,y:e.clientY};

            let newPoints = [...points];
            const canvBounds = canvasRef.current.getBoundingClientRect();
            let relativePoint = {x:newPoint.x-canvBounds.left,y:newPoint.y-canvBounds.top};
         
            if(relativePoint.x<0)
                relativePoint.x = 0;
            if(relativePoint.y<0)
                relativePoint.y = 0;
            if(relativePoint.x>canvasRef.current.offsetWidth)
                relativePoint.x = canvasRef.current.offsetWidth;
            if(relativePoint.y>canvasRef.current.offsetHeight)
                relativePoint.y = canvasRef.current.offsetHeight;

                if(e.shiftKey){
                    relativePoint.x = Math.round(relativePoint.x/10)*10;
                    relativePoint.y = Math.round(relativePoint.y/10)*10;
                }

            let clipPath =  "polygon(";
            for(let i = 0;i<newPoints.length;i++){
                let point = newPoints[i];
                if(i>0)
                    clipPath+=",";
                clipPath+=((point.x *100)/canvasSize)+"% "+((point.y *100)/canvasSize)+"%";
                
            }

            newPoints[dragState] = relativePoint;
            setPoints(newPoints);
            setClipShape(clipPath+")");
  
        
        }
    }

    const startDrag = (pointID:number)=>{

        setDragState(pointID);

    }

    const handleKeyDown = (e:KeyboardEvent)=>{
        if(e.key=="Shift"){
            setShouldSnap(true);
        }
    }
    const handleKeyUp = (e:KeyboardEvent)=>{

        if(e.key=="Shift"){
            setShouldSnap(false);
        }
    }
    const isCustom = definition.options.find((option)=>{return option.value==getClipShape})==undefined;

    const stopDrag = ()=>{
        setDragState(-1);
        if(clipShape!=getClipShape){
            updateFunc(definition.attKey,clipShape,definition.targetType);
        }
  
    }
    const handleTouchMove = (e:TouchEvent)=>{
        if(dragState>=0){
            e.preventDefault();
            e.stopPropagation();
        }

    }

    useEffect(()=>{

        document.addEventListener("pointermove",updateMouse);
        document.addEventListener("pointerup",stopDrag);
        document.addEventListener("keydown",handleKeyDown);
        document.addEventListener("keyup",handleKeyUp);
        document.addEventListener("touchmove",handleTouchMove, { passive: false });

        return ()=>{
            document.removeEventListener("pointermove",updateMouse);
            document.removeEventListener("pointerup",stopDrag);
            document.removeEventListener("keydown",handleKeyDown);
            document.removeEventListener("keyup",handleKeyUp);
            document.removeEventListener("touchmove",handleTouchMove);
        }

    })


    return(
<div className="wb-input-group" style={{padding:"0px"}}>
    <SelectField key={selectKey} siteData= {siteData} layoutObject={layoutObject} screenSize={screenSize} definition={definition} updateFunc={onSelectUpdate} label={label} saveFunc={saveFunc} extraClass=" no-border "/>

    {points.length>0&&
    <Accordian label={<label>Customize Shape</label>}  startExpanded={isCustom} wrapperClass={""} extraStyling={{margin:"16px 0px"}} >
    <div className="flex-row justify-center" style={{padding:"6px 0px 24px 0px"}}>
        <br></br>
        <div className="editor-pattern-bg" ref={canvasRef} style={{width:canvasSize+"px",height:canvasSize+"px",position:"relative",border:"1px solid #c7c7c7"}}>
            <div id="clip-preview"  className = "w-full h-full"style={{clipPath:clipShape,position:"absolute",top:"0",left:"0",background:"grey"}}></div>

                {
                    points.map((point,index)=>{

                        return  <div className="clip-shape-point" onPointerDown={()=>{startDrag(index)}} key ={index}  style={{left:points[index].x+"px",top:points[index].y+"px",borderRadius:(shouldSnap)?"0":"50px"}}></div>

                    })
                }

        </div>
        </div>
    </Accordian>
    }
        </div>
    )
}

export function GenerateWave(freq:number = .8,xOffset:number = 0,yoffset:number = 0,amplitude:number = 1,inverted:boolean = false, numOfPoints:number = 50){

  

    let points = [];

    points.push({x:-.01,y:(inverted)?-1.01:1.01});


    for(let i = 0;i<numOfPoints+1;i++){
        let x = i/numOfPoints;
        let y = Math.sin((x+xOffset)*freq)*amplitude+yoffset;

   

        if(inverted)
            y*=-1;
        points.push({x:x,y:y});
    }

    points.push({x:1.01,y:(inverted)?-1.01:1.01});


    let str = "polygon(";

    for(let i = 0;i<points.length;i++){
        if(i>0)
            str+=",";

        let y = ((points[i].y+1)*50);
        if(y<-1)
            y=-1;
        if(y>101)
            y=101;

        str+=points[i].x*100+"% "+y+"%";
    }

    str+=")";


    return str;

}

export function GenerateWaveMenu({siteData,settings}:{siteData:SiteData,settings:{amplitude:number,freq:number,xOffset:number,yOffset:number,inverted:boolean}}){




    const freqDef = new AttributeDefinition("freq","Frequency","",AttributeInputType.RangeSliderField);
    const offsetDef = new AttributeDefinition("offset","Offset","",AttributeInputType.RangeSliderField);
    const yoffsetDef = new AttributeDefinition("offset","Offset","",AttributeInputType.RangeSliderField);
    const amplitudeDef = new AttributeDefinition("amplitude","Amplitude","",AttributeInputType.RangeSliderField);
    const inverted = new AttributeDefinition("inverted","Inverted","",AttributeInputType.ButtonField,[{label:"Normal",value:""},{label:"Inverted",value:"inverted"}]);

    const previewRef = useRef<HTMLDivElement>(null);

    freqDef.range = {min:.1,max:25,step:.05,default:5,unit:""};
    offsetDef.range = {min:0,max:5,step:.05,default:0,unit:""};
    yoffsetDef.range = {min:-2,max:2,step:.05,default:0,unit:""};
    amplitudeDef.range = {min:0,max:2,step:.05,default:.5,unit:""};
    let layout = new LayoutNode();

    const freqRef  = useRef(5);
    const xoffsetRef  = useRef(0);
    const yoffsetRef  = useRef(0);
    const amplitudeRef  = useRef(.5);
    const invertedRef  = useRef(false);






    const updateClip = ()=>{
        if(previewRef.current){

            previewRef.current.style.clipPath = GenerateWave(freqRef.current,xoffsetRef.current,yoffsetRef.current,amplitudeRef.current,invertedRef.current);
            passToSettings();
        
        }


    }

    const passToSettings =()=>{

        settings.amplitude = amplitudeRef.current;
        settings.freq = freqRef.current;
        settings.xOffset = xoffsetRef.current;
        settings.yOffset = yoffsetRef.current;
        settings.inverted = invertedRef.current;


    }
    passToSettings();
    return (

        <div style={{background:"white",maxWidth:"500px"}}>
            <div style={{background:"#333",width:"100%",height:"200px",clipPath:GenerateWave(5,0,0,.5,false)}} ref={previewRef}>

            </div>
            <div className="flex-row gap-large">
        <SliderField definition={freqDef} layoutObject={layout}     updateFunc={(att,val) => { freqRef.current = parseFloat(val); updateClip(); } } screenSize={ScreenSize.Desktop} siteData={siteData} label={"Wave Frequency"} saveFunc={()=>{}}/>
        <SliderField definition={amplitudeDef} layoutObject={layout}updateFunc={(att,val) => { amplitudeRef.current = parseFloat(val); updateClip(); } }  screenSize={ScreenSize.Desktop} siteData={siteData} label={"Wave Height"} saveFunc={()=>{}}/>
        </div>
        <div className="flex-row gap-large">
        <SliderField definition={offsetDef} layoutObject={layout} updateFunc={(att,val) => { xoffsetRef.current = parseFloat(val); updateClip(); } }  screenSize={ScreenSize.Desktop} siteData={siteData} label={"X Offset"} saveFunc={()=>{}}/>
        <SliderField definition={yoffsetDef} layoutObject={layout} updateFunc={(att,val) => { yoffsetRef.current = parseFloat(val); updateClip(); } }  screenSize={ScreenSize.Desktop} siteData={siteData} label={"Y Offset"} saveFunc={()=>{}}/>
            
        </div>
        <ButtonField definition={inverted} layoutObject={layout} updateFunc={(att,val) => { invertedRef.current = (val=="inverted"); updateClip(); } }  screenSize={ScreenSize.Desktop} siteData={siteData} label={"Axis"} saveFunc={()=>{}}/>
        </div>
        


    )


}


export function GenerateBlob(radius:number = 30,points:number = 5,variance:number = 4,smoothness:number){


    let pointArray = [];

    let angle = 0;
    let angleIncrement = (Math.PI*2)/points;
    
    const normalizeVector = (x:number,y:number)=>{

        let length = Math.sqrt(x*x+y*y);
        return {x:x/length,y:y/length};
    }

    const bezierCurve = (p0:{x:number,y:number},p1:{x:number,y:number},p2:{x:number,y:number},p3:{x:number,y:number},t:number)=>{
        let x = Math.pow(1-t,3)*p0.x+3*Math.pow(1-t,2)*t*p1.x+3*(1-t)*Math.pow(t,2)*p2.x+Math.pow(t,3)*p3.x;
        let y = Math.pow(1-t,3)*p0.y+3*Math.pow(1-t,2)*t*p1.y+3*(1-t)*Math.pow(t,2)*p2.y+Math.pow(t,3)*p3.y;
        return {x:x,y:y};
    }

    //distribute points equally around a circle
    for(let i = 0;i<points;i++){
        let x = Math.cos(angle)*radius+50;
        let y = Math.sin(angle)*radius+50;
        pointArray.push({x:x,y:y});
        angle+=angleIncrement;
    }

    //randomize points
    for(let i = 0;i<pointArray.length;i++){
        let point = pointArray[i];
        point.x+=(Math.random()*2-1)*variance;
        point.y+=(Math.random()*2-1)*variance;
    }

    let smoothedPoints = [];
    //smooth points

    for(let i = 0;i<points;i++){


        smoothedPoints.push(pointArray[i]);
        let point = pointArray[i];
        let nextPoint = pointArray[(i+1)%points];

        for(let s = 0;s<smoothness;s++){
         

            let normal = {x:(nextPoint.y-point.y),y:nextPoint.x-point.x};
            normal = normalizeVector(normal.x,normal.y);
            let p1 = {x:point.x+normal.x*radius,y:point.y+normal.y*radius};

            let normal2 = {x:-(point.y-nextPoint.y),y:point.x-nextPoint.x};
            normal2 = normalizeVector(normal2.x,normal2.y);
            let p2 = {x:nextPoint.x+normal2.x*radius,y:nextPoint.y+normal2.y*radius};
          
            let p = bezierCurve(point,point,p1,p2,s/smoothness)

            smoothedPoints.push(p);
        
        }
    }

    let str = "polygon(";

    for(let i = 0;i<smoothedPoints.length;i++){
        if(i>0)
            str+=",";


        str+=smoothedPoints[i].x+"% "+smoothedPoints[i].y+"%";
    }

    str+=")";



    return str;

}

